<template>
  <v-layout flex align-center justify-center>
    <div>
      <!-- <iframe
        v-if="previewImdb"
        :src="imdbSrc"
        width="480"
        height="270"
        frameborder="no"
        scrolling="no"
      ></iframe> -->
      <iframe
        v-if="previewVimeo"
        :src="vimeoSrc"
        width="480"
        height="270"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
        allow="autoplay;"
      ></iframe>
      <video-player v-if="previewYoutube" v-model="videoOptions"/>
      <video-player v-if="previewUploaded" v-model="videoOptions"/>
    </div>
  </v-layout>
</template>

<script>
import VideoPlayer from "@/components/media/VideoPlayer.vue";

export default {
  name: "EmbedPlayer",
  props: ["value","video_type"],

  components: {
    VideoPlayer
  },
  data() {
    return {
      previewYoutube: false,
      // previewImdb: false,
      previewVimeo: false,
      previewUploaded: false,
      // imdbSrc: null,
      vimeoSrc: null,
      videoOptions: {
        preload: "auto",
        controls: true,
        width: "480",
        height: "270",
        sources: {
          id: "youtube-video",
          poster: null,
          src: null,
          type: null
        }
      }
    };
  },
  mounted() {
    this.validateUrl();
  },
  methods: {
    validateUrl() {
      if (this.value) {
        var youtubeRegExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        if (this.value.match(youtubeRegExp)) {
          this.setYoutubeEmbedUrl();
        } else if (this.value.match(/vimeo.com/i)) {
          this.setVimeoEmbedUrl();
        }
        // else if (this.value.match(/imdb.com/i)) {
        //   this.setImdbEmbedUrl();
        // }
        else  {
          this.setUploadedVideoUrl();
        }
      } else {
        this.$store.dispatch("app/showMessage", {
          message: "Please enter embed url.",
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      }
    },

    setYoutubeEmbedUrl() {
      this.videoOptions.sources.src = this.value;
      this.videoOptions.sources.type = "video/youtube";
      this.previewYoutube = true;
    },

    setUploadedVideoUrl() {
      this.videoOptions.sources.src = this.value;
          this.videoOptions.sources.type = this.video_type;
          this.previewUploaded = true;
    },

    setVimeoEmbedUrl() {
      //if url is vimeo embed player url (eg- https://player.vimeo.com/video/126100721)
      if (/player\.vimeo\.com\/video\/([0-9]{1,10})/.test(this.value)) {
        this.vimeoSrc = this.value;
        this.previewVimeo = true;
        return;
      }
      // if not player url then find video id and create embed player url (eg- https://vimeo.com/126100721)
      var vimeoRegExp = /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/;
      var match = this.value.match(vimeoRegExp);
      if (match) {
        this.vimeoSrc = "https://player.vimeo.com/video/" + match[4];
        this.previewVimeo = true;
      } else {
        this.$store.dispatch("app/showMessage", {
          message: "Please enter a valid url",
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      }
    },

    // setImdbEmbedUrl() {
    //   // find video id from any imdb url and create embed url (eg- vi322422223)
    //   var match = this.value.match(/vi(\d+)/);
    //   if (match) {
    //     this.imdbSrc = "https://www.imdb.com/videoembed/" + match[0];
    //     this.previewImdb = true;
    //   } else {
    //     this.$store.dispatch("app/showMessage", {
    //       message: "Please enter a valid url",
    //       color: this.DEFINES.SNACKBAR_ERROR_COLOR
    //     });
    //   }
    // }
  }
};
</script>
